import React from 'react';
import { graphql} from 'gatsby';
import PropTypes from 'prop-types';

import LinkDropdown from './linkDropDown/linkDropDown';
import HtmlBlock from '../htmlBlock/htmlBlock';
import Link from '../link/link';
import NavigationBlock from '../navigationBlock/navigationBlock';

/**
 * Cms : DatoCmsComponentLinkCollection
 * 
 * Handles Link lists or Dropdowns
 * 
 * Heading + Nav Block + Featured Link
 * 
 */
const LinkCollection = ({data, moduletype, type, ...other}) => {
  const {featuredLink, heading, links} = data || {};
  return (
    type === 'dropdown' ?
    <LinkDropdown data={data} {...other}/>
    :
      <div className={`linkCollection linkCollection--${moduletype.replace('DatoCmsComponent', '')}`}>
      {
        heading && <HtmlBlock tag="h2" data={heading}/>
      }
      <div className="allLinks">
      {
        links.length > 0 &&
        <NavigationBlock data={links} {...other} linkclass="link--text--primary"/>
      }
      {
        featuredLink && featuredLink[0] && 
        <Link data={featuredLink} {...other} className="link--featured--primary"/>
      }
      </div>
    </div>
  );
};

LinkCollection.propTypes = {
  /**
   * CMS Object
   */
  data: PropTypes.shape({
    featuredLink : PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]),
    heading : PropTypes.string,
    links : PropTypes.array,
  }),
  /**
   * Render type
   */
  type: PropTypes.oneOf(['dropdown', 'list'])
}

LinkCollection.defaultProps = {
  type: 'list'
}

export default LinkCollection;

export const LinkCollectionFeaturedFragment = graphql`
  fragment LinkCollectionFeaturedFragment on DatoCmsComponentLinkCollectionFeatured {
    featuredLink{
      ...LinkFragment
    }  
    heading
    links{
      ...LinkFragment
    }
  }`;

  export const LinkCollectionFragment = graphql`
  fragment LinkCollectionFragment on DatoCmsComponentLinkCollection {
    heading
    links{
      ...LinkFragment
    }
  }`;

  export const ImageLinkCollectionFragment = graphql`
  fragment ImageLinkCollectionFragment on DatoCmsComponentImageLinkCollection {
    id: originalId
    heading
    links{
      ...ImageLinkFragment
    }
  }`;